

































import { computed, defineComponent, ref } from '@vue/composition-api';
import { AddCircleIcon, ErrorCircleIcon, MinusCircleIcon } from 'tdesign-icons-vue';
import MessageHandler from '@/renderer/views/message/compositions/messageHandler';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import {
  getMessageFullContent,
  getMessageShowContent,
  getMessageShowLinkBtn,
  getMessageShowTitle,
} from '@/renderer/scripts/utils/MessageHelper';
import { MessageItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';

export default defineComponent({
  components: {
    AddCircleIcon,
    ErrorCircleIcon,
    MinusCircleIcon,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    messageType: {
      type: Number,
      required: true,
    },
    selectMode: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const dateShow = ref(true);
    const { methods: messageMethods } = MessageHandler();

    const strShowContent = computed(() => {
      return getMessageShowContent(props.detail as MessageItem);
    });

    const strFullContent = computed(() => {
      return getMessageFullContent(props.detail as MessageItem);
    });

    const strLinkName = computed(() => {
      return getMessageShowLinkBtn(props.detail as MessageItem);
    });

    const strTitle = computed(() => {
      return getMessageShowTitle(props.detail as MessageItem);
    });

    const methods = {
      mouseEnter() {
        if (!props.selectMode) {
          dateShow.value = false;
        }
      },
      mouseLeave() {
        dateShow.value = true;
      },
      async deleteMessage() {
        try {
          await messageMethods.deleteItemList(props.messageType, [props.detail.id]);
          context.emit('delete');
          reporter.report('notification', {
            notification_delete: props.detail.typeDetail,
          });
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
    };
    return {
      dateShow,
      messageMethods,
      strShowContent,
      strFullContent,
      strLinkName,
      strTitle,
      ...methods,
    };
  },
});
